export default __webpack_public_path__ + "static/media/superfood.7fbd6431.jpg";